import React from 'react';

import { FontAwesomeIcon, type FontAwesomeIconProps } from '@fortawesome/react-fontawesome';
import {
  faBuilding,
  faChairOffice,
  faCity,
  faFence,
  faFlag,
  faHotel,
  faHouse,
  faIndustry,
  faStore,
} from '@fortawesome/pro-regular-svg-icons';

import type { IconDefinition } from '@fortawesome/fontawesome-svg-core';

// Keyed by PropertyType id (see app/models/property_type.rb). Unknown ids fall back to faBuilding.
const ICON_BY_PROPERTY_TYPE_ID: Record<number, IconDefinition> = {
  1: faChairOffice, // Office
  2: faStore, // Retail
  3: faIndustry, // Industrial
  5: faFence, // Land
  6: faCity, // Multifamily
  7: faFlag, // Special Purpose
  8: faHotel, // Hospitality
  10: faHouse, // Residential
};

export function propertyTypeIcon(propertyTypeId: number | null | undefined): IconDefinition {
  return (propertyTypeId != null && ICON_BY_PROPERTY_TYPE_ID[propertyTypeId]) || faBuilding;
}

interface Props extends Omit<FontAwesomeIconProps, 'icon'> {
  propertyTypeId: number | null | undefined;
}

export default function PropertyTypeIcon({ propertyTypeId, ...props }: Props) {
  return <FontAwesomeIcon icon={propertyTypeIcon(propertyTypeId)} {...props} />;
}
